<template>
  <div class="footer-box" id="contactUs">
    <div class="content top">
      <div class="top-iconfont" v-show="this.$store.state.isMobile">
        <div @click="goWeibo"><i class="iconfont">&#xe699;</i></div>
        <div><a href="https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MjM5NzMwNDE3OA==&scene=124#wechat_redirect"><i class="iconfont">&#xe62c;</i></a></div>
      </div>
      <div class="left">
        <p id="title">Kids 'R' Kids上海总部</p>
        <p>
          <i class="iconfont">&#xe66b;</i>
          <span>021 33288991</span>
        </p>
        <p>
          <i class="iconfont">&#xe669;</i>
          <span>上海市闵行区中骏广场一期3号楼N405室</span>
        </p>
        <p>
          <i class="iconfont">&#xe66a;</i>
          <span>contact@kidsrkidschina.com</span>
        </p>
      </div>
      <div class="center">
        <p class="privacy" v-show="this.$store.state.isMobile">
          <span @click.stop="privacy()">隐私政策</span>
        </p>
      </div>
      <div class="right" v-show="!this.$store.state.isMobile">
        <div class="pic" id="pic">
          <img src="../../assets/image/home_qrcode_weixin.png" alt="">
          <p>官方微信</p>
        </div>
        <div class="pic">
          <img
            src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/home/home_code_weibo.jpg"
            alt=""
          >
          <p>官方微博</p>
        </div>
      </div>
    </div>
    <div class="line"></div>
    <div class="content bottom">
      <div class="left">
        <p>© 2012 Kids 'R' Kids China Limited，由凯斯文化传播（杭州）有限公司保留所有权利。</p>
        <a href="https://beian.miit.gov.cn/#/Integrated/index"  style="color:#7a91b0" target="_blank"> 浙ICP备2024059161号-1 </a>
      </div>
      <div class="right">
        <!-- <span @click.stop="sitemap()">网站地图</span> -->
        <span @click.stop="privacy()">隐私政策</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    privacy () {
      // 跳转到隐私政策页面
      this.$uweb.trackEvent('隐私政策', '点击')
      this.$router.push({ name: 'privacy' })
    },
    sitemap () {
      // 跳转到网站地图页面
      this.$uweb.trackEvent('网站地图', '点击')
      this.$router.push({ name: 'sitemap' })
    },
    goWeibo () {
      window.open('https://weibo.com/kidsrkidschina')
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss">
.footer-box {
  width: 100%;
  height: 280px;
  padding-top: 50px;
  box-sizing: border-box;
  overflow: hidden;
  background: rgba(21, 43, 72, 1);
  .top {
    height: 160px;
    .left {
      width: 320px;
      float: left;
      margin-right: 50px;
      margin-top: 10px;
      p {
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular;
        color: rgba(255, 255, 255, 1);
        margin-bottom: 10px;
        img {
          float: left;
          width: 20px;
          height: 20px;
          margin-right: 5px;
        }
        i {
          float: left;
          font-family: "iconfont" !important;
          font-size: 18px;
          font-style: normal;
          margin-right: 5px;
        }
        span {
          float: left;
        }
      }
      #title {
        font-size: 18px;
        margin-bottom: 20px;
      }
    }
    .center {
      width: 320px;
      float: left;
      margin-left: 80px;
      margin-top: 10px;
      p {
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular;
        color: rgba(255, 255, 255, 1);
        margin-bottom: 10px;
        img {
          float: left;
          width: 20px;
          height: 20px;
          margin-right: 5px;
        }
        i {
          float: left;
          font-family: "iconfont" !important;
          font-size: 18px;
          font-style: normal;
          margin-right: 5px;
        }
        span {
          float: left;
        }
      }
      #title {
        font-size: 18px;
        margin-bottom: 20px;
      }
    }
    .right {
      float: right;
      .pic {
        width: 100px;
        background: hsl(0, 0%, 100%);
        float: left;
        margin-left: 50px;
        img {
          width: 100px;
        }
        p {
          width: 100%;
          height: 20px;
          line-height: 20px;
          font-size: 12px;
          text-align: center;
          border-top: 1px dashed #333;
          font-family: PingFangSC-Regular;
        }
      }
      #pic {
        margin-left: 0px;
      }
    }
  }
  .line {
    width: 100%;
    height: 1px;
    background: rgba(8, 26, 50, 1);
  }
  .bottom {
    overflow: hidden;
    margin-top: 5px;
    .left {
      float: left;
      p {
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular;
        color: rgba(122, 145, 176, 1);
        line-height: 24px;
        margin-top: 5px;
      }
    }
    .right {
      float: right;
      span {
        display: inline-block;
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular;
        color: rgba(122, 145, 176, 1);
        line-height: 24px;
        margin-top: 10px;
        margin-left: 30px;
        cursor: pointer;
      }
    }
  }
}
@media (max-width: 768px) {
  .footer-box {
    width: 100%;
    min-height: 490px;
    padding-top: 35px;
    box-sizing: border-box;
    overflow: hidden;
    background: rgba(21, 43, 72, 1);
    position: relative;
    .top {
      .left {
        width: 100%;
        float: left;
        margin-right: 50px;
        margin-top: 10px;
        padding-left: 10%;
        margin-bottom: 22px;
        box-sizing: border-box;
        p {
          line-height: 15px;
          font-size: 12px;
          font-family: PingFangSC-Regular;
          color: rgba(255, 255, 255, 1);
          margin-bottom: 8px;
          img {
            float: left;
            width: 14px;
            height: 14px;
            margin-right: 5px;
          }
          i {
            float: left;
            font-family: "iconfont" !important;
            font-size: 16px;
            font-style: normal;
            margin-right: 10px;
          }
          span {
            float: left;
          }
        }
        #title {
          font-size:12px;
          font-family:PingFangSC-Medium;
          font-weight:500;
          margin-bottom: 18px;
        }
      }
      .center {
        width: 100%;
        float: left;
        margin-top: 0;
        padding-left: 10%;
        box-sizing: border-box;
        margin-left: 0;
        margin-bottom: 22px;
        p {
          line-height: 15px;
          font-size: 12px;
          font-family: PingFangSC-Regular;
          color: rgba(255, 255, 255, 1);
          margin-bottom: 10px;
          img {
            float: left;
            width: 14px;
            height: 14px;
            margin-right: 5px;
          }
          i {
            float: left;
            font-family: "iconfont" !important;
            font-size: 16px;
            font-style: normal;
            margin-right: 10px;
          }
          span {
            float: left;
          }
        }
        .privacy {
          margin-top: 22px;
          margin-bottom: 0;
          span {
            color:rgba(122,145,176,1);
          }
        }
        #title {
          font-size:12px;
          font-family:PingFangSC-Medium;
          font-weight:500;
          margin-bottom: 18px;
        }
      }
    }
    .line {
      display: none;
    }
    .top-iconfont {
      display: flex;
      width: 100%;
      padding-left: 10%;
      padding-bottom: 15px;
      div {
        width: 30px;
        height: 30px;
        line-height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        i {
          font-family: "iconfont" !important;
          font-size: 18px;
          color: #fff;
          font-style: normal;
        }
      }
      div:first-child {
        i {
          font-size: 20px;
        }
      }
    }
    .bottom {
      width: 100%;
      box-sizing: border-box;
      border-top: 1px solid #081A32;
      padding: 0 6%;
      position: absolute;
      bottom: 0;
      height: 79px;
      .left {
        width: 100%;
        padding-top: 10px;
        p {
          text-align: center;
          font-size:10px;
          font-family:SourceHanSansCN-Regular;
          font-weight:400;
          color:rgba(122,145,176,1);
          line-height:15px;
          height: 30px;
        }
        p:last-child {
          margin-top: 4px;
        }
      }
      .right {
        display: none;
      }
    }
  }
}
@media (min-width: 415px) and (max-width: 768px) {
	.footer-box {
    .bottom {
      width: 100%;
      .left {
        p {
          text-align: center;
          font-size:10px;
          font-family:SourceHanSansCN-Regular;
          font-weight:400;
          color:rgba(122,145,176,1);
          line-height:15px;
          height: 15px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/footer.vue